import { render, staticRenderFns } from "./header.vue?vue&type=template&id=55ed2f45&scoped=true&v=2.1.45"
import script from "./header.vue?vue&type=script&lang=js&v=2.1.45"
export * from "./header.vue?vue&type=script&lang=js&v=2.1.45"
import style0 from "./header.vue?vue&type=style&index=0&id=55ed2f45&lang=scss&scoped=true&v=2.1.45"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ed2f45",
  null
  
)

export default component.exports